module.exports = __webpack_public_path__ + "img/DSC_0597.19012d9b.jpeg";